<template >
<div >
    <v-layout v-if="!page_show">
        <not-page-spinner :not_show="true" /> 
    </v-layout>  
    <v-container v-else grid-list-xs>
        <v-row>
            <v-col sm="4">
                <v-layout column=""> 
                    <v-card >
                        <v-card-title class="primary white--text">
                            COMMUNITIES
                        </v-card-title>
                        <v-card-text>
                            <v-list single-line dense="" color="b2m">
                                <div color="b2" v-for="(item, index) in communities?communities.slice(0,10):null" :key="index"
                                >
                                    <v-list-item :to="'/about/communities/'+item.name">{{item.name}}</v-list-item>
                                    <v-divider></v-divider>
                                </div> 
                            </v-list>
                            <v-layout justify-center="">
                                <v-btn color="primary" outlined="" :to="'/about/communities'">View all</v-btn>
                            </v-layout>
                        </v-card-text> 
                    </v-card>

                    <v-card class="mt-2">
                        <v-card-title class="primary white--text">
                            CONGREGATION
                        </v-card-title>
                        <v-card-text>
                            <v-list single-line dense="" color="b2m">
                                <div color="b2" v-for="(item, index) in congregations" :key="index">
                                    <v-list-item >{{item.name}}</v-list-item>
                                    <v-divider></v-divider>
                                </div> 
                            </v-list>
                        </v-card-text> 
                    </v-card>
                     
                </v-layout>
            </v-col>
            <v-col sm="8" cols="12">
                <v-layout column>
                    <v-card     
                        color="primary"  
                        width="" hover=""  class="pa-1" outlined="">
                        <v-layout c justify-center="" align-center="" class="pa-9 white font-weight-bold primary--text">
                            <div class="not-f8">{{not.TEXT_UP(thisCommunity.name)}} COMMUNITY</div>
                        </v-layout>
                    </v-card>

                    <v-layout row wrap class="mt-5">
                        <v-card class=""
                                elevation="2"
                                max-width="100%"> 
                                <v-layout row wrap>
                                    <div class="not-f7 font-weight-bold pa-5 primary--text">Sisters</div>
                                    <v-spacer></v-spacer>
                                    <div class="pa-5">
                                        <v-text-field  color="primary" v-model="nameSearch"
                                            background-color="primary lighten-4" 
                                            placeholder="Type sister's name"
                                            id="search"
                                            rounded=""  dense=""
                                            outlined="" 
                                            label="Search Sister"
                                            append-icon="search"
                                        ></v-text-field> 
                                    </div> 
                                </v-layout>
                                <hr>
                                <div class="px-5 font-italic">Total number of Sisters in this community: {{thisSistrs?thisSistrs.length:0}}</div>
                             
                            <div class="px-5">
                                <v-row>
                                    <v-col sm="6" md="4" cols="12" v-for="(study, index) in p_sisters?p_sisters.list:null" :key="index" class="px-1">
                                        <v-card :to="'sisters/'+study.key" flat="" color="" height="100%" hover=""  class="px-" outlined="">
                                            <v-hover v-slot:default="{hover}">
                                                <v-layout column fill-height> 
                                                    <!-- //IMAGE -->
                                                    <div> 
                                                        <div v-if="!study.image">
                                                            <v-img
                                                                :src="not.noImg"
                                                                :lazy-src="not.imgLazy"
                                                                aspect-ratio="1.1"
                                                                class="grey lighten-2"/>  
                                                        </div>
                                                        <div v-else>
                                                            <v-img
                                                                :src="study.image.link"
                                                                :lazy-src="not.imgLazy"
                                                                aspect-ratio="1.2"
                                                                class="grey lighten-2"/>  
                                                        </div>
                                                    </div>
                                                    <!-- //CONTENT -->
                                                    <v-sheet   class="px-2 pb-">
                                                        <div class="pt-1">
                                                            <div class="not-f6 font-weight-bold text-center">
                                                                <div v-if="not.size(study.name)<20">{{study.name}}</div>
                                                                <div v-else>{{study.name.substring(0,20)+"..."}}</div> 
                                                            </div> 
                                                        </div>
                                                        <div class="">
                                                            <div class="not-f4 font-weight-bold text-center font-italic primary--text">
                                                                <div v-if="not.size(study.apostolate)<20">{{study.apostolate}}</div>
                                                                <div v-else>{{study.apostolate.substring(0,20)+"..."}}</div> 
                                                            </div> 
                                                        </div>
                                                        <div class="pb-3">
                                                            <div class="not-f6 font-weight-bol text-center ">
                                                                <div v-if="not.size(study.congregation_name)<20">{{study.congregation_name}}</div>
                                                                <div v-else>{{study.congregation_name.substring(0,20)+"..."}}</div> 
                                                            </div> 
                                                        </div> 
                                                    </v-sheet>
                                                    <v-spacer></v-spacer>  
                                                    <v-divider></v-divider>
                                                    <v-layout row wrap justify-center="" class="pa-2">
                                                        <v-btn icon="" class="primary mr-1" dark="" size="15"><v-icon>mdi-phone</v-icon></v-btn>
                                                        <v-btn icon="" class="primary mr-1" dark="" size="15"><v-icon>message</v-icon></v-btn>
                                                        <v-btn icon="" class="primary" dark="" size="15"><v-icon>email</v-icon></v-btn>
                                                    </v-layout> 
                                                </v-layout> 
                                            </v-hover> 
                                        </v-card>
                                    </v-col> 
                                </v-row> 

                            </div>
                            <!-- //Pagination -->
                            <br>
                            <v-divider></v-divider>
                            <div class="px-5">
                                <v-pagination
                                    v-model="page_current"
                                    class="mt-4"
                                    :length="p_sisters?p_sisters.pages:0"/> 
                            </div>             
                        </v-card> 
                    </v-layout>

                </v-layout> 
            </v-col>
            
        </v-row>
    </v-container>
   <not-image-crop 
        v-model="dialogCrop"
        lang-type="en"
        imageFormarty="jpg"
        @crop-success="cropSuccess"
        :height="250"
        :width="250"
        :noRotate="false"
        :noCircle ="false"
        :noSquare="true"/> 
</div>
</template>

<script>
    let pageName = "Sister"
    export default{
        props:["id","not"],
        name: pageName,  
        data: () => ({
            page_show: false,  
            dialogCrop:false,
            loadingImage:false,
            processValue: 0,
            nameSearch:'',
            page_current:1,
            page_size:12,
            images:[
                {src:'/images/teresian/t6.JPG',local:true},  
            ],
           
        }),
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
            this.EventBus.$on('notNoDialog', this.notNoDialog);
            this.pageLoad(500)
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notImages:this.images,
                notText:false,
                notIndicators:true,
                notHeight:300
            }) 
            this.pageLoad(1000)
        },
        updated(){
            //this.page_show =false
            // this.pageLoad(500)
            // console.log("UPppppppppp");
            
        },
        //---------computed-----------
        computed: { 
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            congregations(){
                return this.$store.getters.getCongregation
            },
            positions(){
                let sisters = this.Sisters
                if(!sisters){return null}
                let positions = []
                sisters.forEach(element => {
                    let pos = element.position
                    let index = positions.indexOf(pos)
                    if (index ===-1) {
                        positions.push(pos)
                    }
                });
                return positions
            },

            sisters(){
                return this.$store.getters.getSisters
            },
            thisSistrs(){
                let sisters = this.sisters
                if(!sisters){return null}
                return sisters.filter(sis=>{
                    return sis.community == this.thisCommunity.name
                })
            },
            thisCommunity(){
                let id = this.id;
                let ms = this.communities
                if (!ms) {
                    return null
                }
                return ms.find(m=>{
                    return m.name == id
                })
            },
            JOINED_sisters(){
                let sisters = this.thisSistrs 
                let joinSisters = this.not.JOIN_SISTERS(sisters)
                return joinSisters
            },
            communities(){
                let sisters = this.sisters 
                let communities = this.not.JOIN_COMMUNITIES(sisters) 
                if (!communities) {
                    return null
                }
                //Search through  sisters
                return communities.filter(mm=>{
                    let name = this.not.TEXT_UP(mm.name) 
                    let nameSearch = this.not.TEXT_UP(this.nameSearch1)
                    let index = 1
                    if (nameSearch) {
                        index = name.indexOf(nameSearch)
                    }
                    return index != -1
                })
            },
            p_sisters(){
                if (!this.JOINED_sisters) {
                    return null
                }
                let list = [...this.JOINED_sisters]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
        },

        //--------methods-----------
        methods:{
            notYesDialog(action){ 
                if (action.code) {
                    if (action.code===pageName+':'+1) { 
                        this.$store.dispatch("fi_uploadImage",{
                            action:"Sisters",
                            path:"SETTINGS/Sisters",
                            key:action.key,
                            image:action.image,
                        }) 
                    }
                    if (action.code===pageName+':'+2) { 
                        this.$store.dispatch("fi_deleteImage",{
                            path:"AWRIM/SETTINGS/Sisters/"+action.key,
                            link:action.image.link,
                            action:"AWRIM/SETTINGS/Sisters"
                        }) 
                    }
                } 
            }, 
            notNoDialog(action){
                if (action.code) { 
                    
                }  
            }, 
            cropSuccess(imgDataUrl,field){ 
                this.not.notDialog(true,true,"ADD IMAGE","Are you sure you want to add this image?","CANCEL","ADD",{
                    code:pageName+':'+1,
                    image:imgDataUrl,
                    key:this.thisStudy.key
                }) 

            },
            deleteImage(item){
                this.not.notDialog(true,true,"DELETE IMAGE","Are you sure you want to delete this image?","CANCEL","DELETE",{
                    code:pageName+':'+2,
                    image:item.image,
                    key:item.key
                }) 
            },

            //LOAD
            show(){
                if (!this.thisStudy) {
                    this.page_show = false
                }else{
                    this.page_show = true
                }
            },
            pageLoad(t){
                if (!t) {
                    t=400
                } 
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    this.show()

                   //Check proccess 
                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/Sisters'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/image/BibleStudy'
                        }) 
                        let deletingImage = ps.find(process=>{
                            return process.name == 'deleting/image/Sisters'
                        })

                        if (getting) {
                            this.page_show =false
                        }else{
                            this.page_show =true
                        }

                        if (adding) {
                            this.not.notDialogP(true,true,'uploading...') 
                        }else{
                            // this.not.notDialogP(false)
                            // this.input.loading = false
                        }    

                        if (deletingImage) {
                            this.not.notDialogP(true,true,'deleting image...') 
                        }else{
                            //this.not.notDialogP(false) 
                        }  
                    }else{
                         
                    } 
                     

                    //check response
                    if (res.res==='uploading/image/Sisters/successful') { 
                        this.not.notDialog(true,true,'Successful','Image, successfuly added.','','OK') 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='uplading/image/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding image.','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/image/Sisters/successful') { 
                        this.not.notDialog(true,true,'Successful','Image, successfuly deleted.','','OK')
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/image/Sisters/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting bible study.','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            },
             //UPLOAD
            pageUploadImage(){
                let us = this.us 
                let ps = this.processes
                let rs = this.responses
                let ld = this.loading  

                //find
                if (ps) { 
                    let bs = ps.find(process=>{
                        return process.name == "uploading/image/Sisters"
                    }) 
                    if (bs) { 
                        this.loadingImage = true
                        this.processValue =bs.val
                    }else{
                        this.loadingImage = false
                    } 
                }else{
                    this.loadingImage = false
                }
            } 
        }, 
        watch: {
            us(v){
                this.show()
            },
            loading(value){
                this.pageLoad(1)
                this.pageUploadImage()
            },
            processes(value){
                this.pageLoad(1)
                this.pageUploadImage()
            },
            responses(value){
                this.pageLoad(1) 
                this.pageUploadImage()
            },
            thisStudy(v){
                this.page_show = false
                this.pageLoad(500)
            }
        },
    } 
    
</script>

 